import type { HeaderFilterConfig } from './types';

/**
 * A filter narrows the rows when some, but not all, of its options are on, or
 * when a value is on that the list no longer offers (it still filters, and the
 * list cannot untick it).
 */
export function isFilterActive(
  filter: HeaderFilterConfig | undefined
): boolean {
  return (
    !!filter &&
    filter.selected.length > 0 &&
    (filter.selected.length < filter.options.length ||
      filter.selected.some(v => !filter.options.some(o => o.value === v)))
  );
}
